module.exports = __webpack_public_path__ + "img/ja_jp.7665ce32.png";